import React, { Component } from "react";
import MapApp from "./components/MapApp";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MainApp from "./components/MainApp";
import { city_part_client_type, city_proj_client_type, school_part_client_type, school_proj_client_type } from "./components/MapContainer";

class App extends Component {
  state = {};
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/complete">
            <MapApp showAllProviders={true} />
          </Route>
          <Route path="/all">
            <MapApp />
          </Route>
          <Route path="/schools">
            <MapApp showClients={[school_part_client_type, school_proj_client_type]} />
          </Route>
          <Route path="/cities">
            <MapApp showClients={[city_part_client_type, city_proj_client_type]} />
          </Route>
          <Route path="/admin">
            <MainApp />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default App;
